import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGetMerchantEarningsReportRequest {
    page: number;
    size: number;
    orderByDesc?: boolean;
    orderBy?: string;
    status?: string;
    merchantIds?: string;
    startDate?: string;
    endDate?: string;
}

export interface MerchantEarningsReportItem {
    merchantId: number | null;
    merchantName: string | null;
    paymentMerchantDate: string;
    merchantAmount: number;
    paidAmount: number | null;
}

export interface MerchantEarningsReportResponse {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
    orderBy: string;
    orderByDesc: boolean;
    result: MerchantEarningsReportItem[];
}

async function getMerchantEarningsReport(
    data: IGetMerchantEarningsReportRequest
): Promise<any> {
    try {
        return (await axiosInstance.post("/Merchant/GetMerchantEarningsReport", data)).data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantEarningsReport() {
    return useMutation<any, Error, IGetMerchantEarningsReportRequest>((variables) =>
        getMerchantEarningsReport(variables)
    );
}